import { container } from 'tsyringe'
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators'
import store from '@/app/store/store'
import {
  AdditionalApiRequest,
  UpdateAdditionalRequest,
  DeleteAdditionalRequest,
} from '@/data/payload/api/AdditionalInfoRequest'
import { AdditionalInfoPresenter } from '@/app/ui/presenters/AdditionalInfoPresenter'
import { AdditionalInfo } from '@/domain/entities/AdditionalInfo'
import router from '@/router'
import Vue from 'vue'
import { AuthModule } from './auth'

export interface AdditionalState {
  additionalData: AdditionalInfo
  isLoading: boolean
  fields: any
  paginationParam: Object
}

@Module({ namespaced: true, dynamic: true, store, name: 'additionalInfo' })
class Additionals extends VuexModule implements AdditionalState {
  public additionalData = new AdditionalInfo(true, '')
  public isLoading = true
  public Pages = 0
  public Limit = 10
  public fields = [
    { key: 'selected', sortable: false },
    { key: 'no', sortable: false },
    { key: 'fileCode', sortable: false },
    { key: 'title', sortable: true },
    { key: 'isActive', sortable: false },
    { key: 'Owner', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'expiredDate', sortable: false },
    { key: 'actions', sortable: false },
  ]
  public paginationParam = {
    paging: {
      page: 1,
      limit: 10,
    },
    sort: {
      column: 'CreateDate',
      type: 'desc',
    },
    search: '',
  }

  @Action
  public async getAdditonalData() {
    this.setLoading(true)
    const presenter = await container.resolve(AdditionalInfoPresenter)
    presenter
      .loadAdditionalInfo(this.paginationParam)
      .then((res: AdditionalInfo) => {
        this.setLoading(false)
        this.setBulletinData(res)
        this.setpages(this.paginationParam.paging.page)
        this.setlimit(this.paginationParam.paging.limit)
        //  console.log('data', res)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          AuthModule.logOut()
          router.push(`/login`).then(() => {
            Vue.prototype.$notify({
              title: 'Session Expired',
              message: 'Session was expired please login again',
              type: 'error',
              duration: 3000,
            })
          })
        }
        this.setLoading(false)
        router.push('/404/index')
        console.error('error', error)
      })
  }

  @Action
  public async postAdditional(params: {
    title: string
    fileCode: string
    ownerId: string
    imageThumbnailId: number
    isActive: boolean
    isDownloadable: boolean
    isRecommended: boolean
    fileName: string
    fileByte: string
    fileUpload: any
    expireddate: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(AdditionalInfoPresenter)
    presenter
      .postAdditionalInfo(
        new AdditionalApiRequest(
          params.title,
          params.fileCode,
          params.imageThumbnailId,
          params.isActive,
          params.isDownloadable,
          params.isRecommended,
          params.fileName,
          params.fileByte,
          params.fileUpload,
          params.expireddate,
          params.ownerId
        )
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Additional',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getAdditonalData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async updateAdditional(params: {
    id: number
    fileCode: string
    title: string
    imageThumbnailId: number
    isActive: boolean
    isDownloadable: boolean
    isRecommended: boolean
    fileName: string
    fileByte: string
    fileUpload: any
    expireddate: string
  }) {
    this.setLoading(true)
    const presenter = await container.resolve(AdditionalInfoPresenter)
    presenter
      .updateAdditionalInfo(
        new UpdateAdditionalRequest(
          params.title,
          params.fileCode,
          params.imageThumbnailId,
          params.isActive,
          params.isDownloadable,
          params.isRecommended,
          params.fileName,
          params.fileByte,
          params.fileUpload,
          params.expireddate
        ),
        params.id
      )
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Additional',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getAdditonalData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Action
  public async deleteAdditional(params: { ids: any }) {
    this.setLoading(true)
    const presenter = await container.resolve(AdditionalInfoPresenter)
    presenter
      .deleteAdditionalInfo(new DeleteAdditionalRequest(params.ids))
      .then((res) => {
        Vue.prototype.$notify({
          title: 'Additional',
          message: res.message,
          type: res.success === true ? 'success' : 'error',
          duration: 5000,
        })
        this.getAdditonalData()
      })
      .catch((error) => {
        this.setLoading(false)
        //  console.log(error)
      })
  }

  @Mutation
  private setBulletinData(additional: AdditionalInfo) {
    this.additionalData = additional
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }

  @Mutation
  private setpages(pages: number) {
    this.Pages = pages
  }
  @Mutation
  private setlimit(limit: number) {
    this.Limit = limit
  }
}

export const AdditionalModule = getModule(Additionals)
